import NiceModal, { NiceModalContext } from '@ebay/nice-modal-react';
import { useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
export function DialogProvider({ children }: React.PropsWithChildren) {
    return (
        <NiceModal.Provider>
            <CloseDialogsOnNavigate />
            {children}
        </NiceModal.Provider>
    );
}

/** Dialogs render outside the route, so navigating would otherwise leave them over the new page. */
function CloseDialogsOnNavigate(): null {
    const store = useContext(NiceModalContext);
    const { pathname } = useLocation();
    const storeRef = useRef(store);

    useEffect(() => {
        storeRef.current = store;
    }, [store]);

    useEffect(() => {
        for (const [id, modal] of Object.entries(storeRef.current)) {
            if (modal.visible) {
                NiceModal.remove(id);
            }
        }
        // Pathname only: the `d_*` query-param dialogs drive their own navigation.
    }, [pathname]);

    return null;
}

export type DialogStateManager = typeof NiceModal;
export const DialogStateManager = NiceModal;

export const useDialog = NiceModal.useModal;
